import ApiResourceManager from '../ApiResourceManager';

export default class OnboardingStepsManager extends ApiResourceManager {
  get = () =>
    this.request({
      method: 'GET',
      url: '/onboarding-steps',
    });

  // `onBehalfOf` overrides the tenant headers for this one request. The
  // partner-onboarding wizard (FOO-6351 C1) uses it to mark Phase 1 complete
  // for a just-created company before the api client has re-memoised its headers
  // around the new current company. Both the company AND its franchise are
  // overridden so the request never mixes the new company with the previously
  // selected tenant's franchise.
  markComplete = (data, onBehalfOf = null) =>
    this.request({
      method: 'POST',
      url: '/complete-onboarding-steps',
      data,
      ...(onBehalfOf?.companyId
        ? {
            headers: {
              'x-on-behalf-of-company': `${onBehalfOf.companyId}`,
              ...(onBehalfOf.franchiseId ? { 'x-on-behalf-of-franchise': `${onBehalfOf.franchiseId}` } : {}),
            },
          }
        : {}),
    });
}
